import React, { Component } from "react";
import ProjectDetailsModal from "./ProjectDetailsModal";
import "./Projects.scss";
import { 
  trackSectionView, 
  trackProjectView, 
  trackProjectModalOpen,
  trackTimeOnSection 
} from "../utils/analytics";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deps: {},
      detailsModalShow: false,
    };
    this.sectionRef = React.createRef();
    this.sectionStartTime = null;
    this.hasTrackedView = false;
  }

  componentDidMount() {
    this.setupIntersectionObserver();
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.trackTimeSpent();
  }

  setupIntersectionObserver = () => {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.sectionStartTime = Date.now();
            if (!this.hasTrackedView) {
              trackSectionView('mobile_projects');
              this.hasTrackedView = true;
            }
          } else {
            this.trackTimeSpent();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (this.sectionRef.current) {
      this.observer.observe(this.sectionRef.current);
    }
  };

  trackTimeSpent = () => {
    if (this.sectionStartTime) {
      const timeSpent = Math.round((Date.now() - this.sectionStartTime) / 1000);
      if (timeSpent > 1) {
        trackTimeOnSection('mobile_projects', timeSpent);
      }
      this.sectionStartTime = null;
    }
  };

  render() {
    let detailsModalShow = (data) => {
      trackProjectView(data.title, 'mobile');
      trackProjectModalOpen(data.title);
      this.setState({ detailsModalShow: true, deps: data });
    };

    let detailsModalClose = () => this.setState({ detailsModalShow: false });
    
    if (this.props.resumeProjects && this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.projects;
      var projects = this.props.resumeProjects.map(function (projects, index) {
        return (
          <div className="mobile-project-card" key={projects.title} style={{ animationDelay: `${index * 0.1}s` }}>
            <div className="mobile-project-image-wrapper">
              <img
                src={projects.images[0]}
                alt={`${projects.title} mobile app screenshot`}
                className="mobile-project-image"
                loading="lazy"
                decoding="async"
              />
              <div className="mobile-project-overlay">
                <div className="mobile-project-actions">
                  <button 
                    className="view-details-btn"
                    onClick={() => detailsModalShow(projects)}
                  >
                    <span className="btn-icon">📱</span>
                    View App
                  </button>
                </div>
              </div>
              {!!projects.startDate && (
                <div className="mobile-project-date">{projects.startDate}</div>
              )}
            </div>
            
            <div className="mobile-project-content">
              <h3 className="mobile-project-title">{projects.title}</h3>
              <p className="mobile-project-description">
                {projects.description || "Tap to explore this mobile application"}
              </p>
              
              <div className="mobile-project-tech">
                {projects.technologies && projects.technologies.slice(0, 3).map((tech, i) => (
                  <span key={i} className="tech-tag">{tech.name}</span>
                ))}
                {projects.technologies && projects.technologies.length > 3 && (
                  <span className="tech-more">+{projects.technologies.length - 3} more</span>
                )}
              </div>
              
              <div className="app-store-badges">
                <div className="badge ios">iOS</div>
                <div className="badge android">Android</div>
              </div>
            </div>
          </div>
        );
      });
    }

    return (
      <section className="mobile-projects-section" id="mobile-projects" ref={this.sectionRef}>
        <div className="container">
          <div className="projects-header">
            <h2 className="section-title">Mobile App Projects</h2>
            <div className="section-divider"></div>
            <p className="section-subtitle">
              Native and cross-platform mobile applications for iOS and Android
            </p>
          </div>
          
          <div className="mobile-projects-grid">
            {projects}
          </div>
          
          <ProjectDetailsModal
            show={this.state.detailsModalShow}
            onHide={detailsModalClose}
            data={this.state.deps}
          />
        </div>
      </section>
    );
  }
}

export default Projects;
